import { useEffect, useRef } from "react";
import { motion, useInView } from "framer-motion";

const TILES = [
  {
    type: "video",
    src: "/assets/umemulo-vid.mp4",
    caption: "A Suitor's Tribute (umemulo)",
  },
  {
    type: "video",
    src: "/assets/ocean-vid.mp4",
    caption: "(Incwadi Encane) The Letter",
  },
  {
    type: "video",
    src: "/assets/cows-vid.mp4",
    caption: "Iyacelwa Intombi (Lobola)",
  },
  {
    type: "video",
    src: "/assets/proposal-vid.mp4",
    caption: "Indandatho (The Ring)",
  },
  {
    type: "video",
    src: "/assets/food-vid.mp4",
    caption: "Iyaphakelwa Indoda(Respectfully Serving)",
  },
  {
    type: "image",
    src: "/assets/gallery-1.jpg",
    alt: "uMaMdineka and uMfanelo in traditional attire",
    caption: "Futhi Iyalungiswa(Dressing/Fixing)",
  },
  {
    type: "image",
    src: "/assets/gallery-2.jpg",
    alt: "The couple sharing a joyful moment in the hills",
    caption: "Officially Became Ingoduso ka Mphemba",
  },
];

const VideoTile = ({ src, index }) => {
  const ref = useRef(null);
  const inView = useInView(ref, { margin: "-15% 0px -15% 0px" });

  useEffect(() => {
    const v = ref.current;
    if (!v) return;
    if (inView) {
      v.play().catch(() => {});
    } else {
      v.pause();
    }
  }, [inView]);

  return (
    <video
      ref={ref}
      data-testid={`gallery-video-${index}`}
      src={src}
      autoPlay
      muted
      loop
      playsInline
      preload="auto"
      className="h-full w-full object-cover"
    />
  );
};

export default function Gallery() {
  return (
    <motion.section
      data-testid="gallery"
      initial={{ opacity: 0, y: 48 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-60px" }}
      transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1] }}
      className="relative bg-[#FAF8F5] px-6 py-24 sm:py-32"
    >
      <div className="mx-auto max-w-4xl text-center">
        <h2 className="mt-3 font-serif-lux text-3xl font-medium tracking-tight text-[#4A3B32] sm:text-4xl">
          The Two Becoming One
        </h2>
        <div className="mx-auto mt-4 h-px w-16 bg-[#C5A059]/70" />
        <p
          data-testid="gallery-swipe-hint"
          className="mt-3 text-sm tracking-[0.35em] text-[#C5A059]"
          aria-hidden="true"
        >
          - - - -&gt; &gt; &gt;
        </p>
        <div className="mt-10 flex snap-x snap-mandatory gap-5 overflow-x-auto pb-4 sm:grid sm:grid-cols-3 sm:overflow-visible sm:pb-0">
          {TILES.map((tile, i) => (
            <motion.div
              key={tile.src}
              initial={{ opacity: 0, y: 32 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{
                duration: 0.8,
                delay: i * 0.12,
                ease: [0.22, 1, 0.36, 1],
              }}
              className="w-64 shrink-0 snap-center sm:w-auto"
            >
              <div className="aspect-[3/4] overflow-hidden rounded-2xl border border-[#C5A059]/40 shadow-[0_16px_48px_rgba(74,59,50,0.18)]">
                {tile.type === "image" ? (
                  <img
                    src={tile.src}
                    alt={tile.alt}
                    loading="lazy"
                    className="h-full w-full object-cover"
                  />
                ) : (
                  <VideoTile src={tile.src} index={i} />
                )}
              </div>
              <p className="mt-3 text-center font-script text-2xl text-[#5A3A5A]">
                {tile.caption}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </motion.section>
  );
}
